import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { AuthActions } from '../auth';
import { CartServiceV2 } from './cart-store.service';
import { CartActionsV2 } from './cart.actions';

@Injectable()
export class CartEffectsV2 {
  constructor(
    private actions$: Actions,
    private cartService: CartServiceV2,
    private router: Router,
    private store: Store
  ) {}

  cleanUserCart2$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActionsV2.cleanUserCart),
      mergeMap(() => {
        this.cartService.cleanUserCart();
        return of(CartActionsV2.cleanUserCartSuccess(), AuthActions.userAuthInfoClean());
      })
    )
  );

  initUserCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActionsV2.initUserCart),
      switchMap(() =>
        this.cartService.initUserCart().pipe(
          map((cartItems) => {
            return CartActionsV2.initUserCartSuccess({ cartItems });
          }),
          catchError((error) => of(CartActionsV2.loadCartFail({ error })))
        )
      )
    )
  );

  loadCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActionsV2.loadCart),
      switchMap(() =>
        this.cartService.loadCart().pipe(
          map((cartItems) => {
            if (this.router.url === '/checkout' || this.router.url === '/en/checkout') {
              if (cartItems.coursesData.length === 0) {
                window.location.replace('./checkout?status=completed');
              }
            }
            return CartActionsV2.loadCartSuccess({ cartItems });
          }),
          catchError((error) => of(CartActionsV2.loadCartFail({ error })))
        )
      )
    )
  );

  addToCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActionsV2.addToCart),
      switchMap((courseData) =>
        this.cartService.addToCart(courseData).pipe(
          map((cartItems) => {
            return CartActionsV2.addToCartSuccess({ cartItems });
          }),
          catchError((error) => {
            return of(CartActionsV2.loadCartFail({ error }));
          })
        )
      )
    )
  );

  removeToCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActionsV2.removeToCart),
      switchMap(({ id }) =>
        this.cartService.removeToCart(id).pipe(
          map((cartItems) => CartActionsV2.removeToCartSuccess({ cartItems })),
          catchError((error) => of(CartActionsV2.loadCartFail({ error })))
        )
      )
    )
  );
}
